import { SVGAttributes } from "react";

export function CaretDownIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M26.7075 12.7075L16.7075 22.7075C16.6146 22.8005 16.5043 22.8742 16.3829 22.9246C16.2615 22.9749 16.1314 23.0008 16 23.0008C15.8686 23.0008 15.7385 22.9749 15.6171 22.9246C15.4957 22.8742 15.3854 22.8005 15.2925 22.7075L5.29251 12.7075C5.10487 12.5199 4.99945 12.2654 4.99945 12C4.99945 11.7346 5.10487 11.4801 5.29251 11.2925C5.48015 11.1049 5.73464 10.9994 6.00001 10.9994C6.26537 10.9994 6.51987 11.1049 6.70751 11.2925L16 20.5863L25.2925 11.2925C25.3854 11.1996 25.4957 11.1259 25.6171 11.0756C25.7385 11.0253 25.8686 10.9994 26 10.9994C26.1314 10.9994 26.2615 11.0253 26.3829 11.0756C26.5043 11.1259 26.6146 11.1996 26.7075 11.2925C26.8004 11.3854 26.8741 11.4957 26.9244 11.6171C26.9747 11.7385 27.0006 11.8686 27.0006 12C27.0006 12.1314 26.9747 12.2615 26.9244 12.3829C26.8741 12.5043 26.8004 12.6146 26.7075 12.7075Z"
        fill="#C3C7D3"
      />
    </svg>
  );
}
